import React from 'react';
import { useState } from 'react';
import { Dialog, DialogActions, Button } from '@mui/material';
import * as columns_info from '../../misc/Columns.ts';
import { NewOrEdit } from '../NewOrEdit.tsx';
import { MonitoringData } from './MonitoringData.tsx';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import { LovInfoDictionary } from '../../misc/LovInfoDictionary.tsx';
import * as common from './Common.ts';
import * as frac_api from "../../api/FracApi.ts";
import {CircularProgress} from '@mui/material';

const currentYear = new Date().getFullYear();

const defaultData: MonitoringData = {
    id: -1,
    country: [],
    year: currentYear,
    frac_moa_code: "",
    pest_sci_name: "",
    crop_sci_name: "",
    companies: [],
    monitoring_type: "",
    monitoring_intensity: "",
    resistance_frequency: [],
    resistance_mechanism: "",
    mechanism_detail: "",
    geo_distribution: "",
    resistance_factor: "",
    resistance_field_relevance: "",
    comments: "",
    last_update: ""
}


export function ResistanceDataPageNew({
    columns,
    showNew,
    onHandleClose,
    onHandleNewPressed,
    lovs
}: {
    columns: columns_info.ColumnInfo[],
    showNew: boolean,
    onHandleClose:  ()  => void,
    onHandleNewPressed:  (rec: frac_api.ResistanceData) => Promise<void>,
    lovs: LovInfoDictionary
}) {
    const [isLoding, setIsLoading] = useState(true);
    const { showMessage } = useSnackbarMessage();
    const [isAdding, setIsAdding] = useState(false);


    const [newColumns, setNewColumns] = useState<columns_info.ColumnInfo[]>(() => {
        var columnsCopy = [...columns];
        const countryCol = columnsCopy.find((col) => col.id === "country");
        if (countryCol) {
            countryCol.multi = true;

        } else {
            showMessage("Internal error, can't find column. Please contact support.");
        }

        return columns;
    });

    const [newData, setNewData] = useState<MonitoringData>(defaultData);

    const handleClear = () => {
        setNewData(defaultData);
    }

    const handleUpdateAndClose = async () => {
        try {
            setIsAdding(true);
            const rec = common.convertFormDataToRecord(newData, lovs);
            const { valid, error } = common.validateRecord(rec);

            if (!valid) {
                showMessage(error);
                return;
            }

            await onHandleNewPressed(rec);
            handleClose();
        } catch (error) {
            console.error("Error updating record: " + error);
            showMessage("Error updating record. Please try again.");
        } finally {
            setIsAdding(false);
        }
    }


    const handleUpdate = async () => {
        try {
            setIsAdding(true);
            const rec = common.convertFormDataToRecord(newData, lovs);
            const { valid, error } = common.validateRecord(rec);

            if (!valid) {
                showMessage(error);
                return;
            }

            await onHandleNewPressed(rec);
        } catch (error) {
            console.error("Error updating record: " + error);
            showMessage("Error updating record. Please try again.");

        } finally {
            setIsAdding(false);
        }
    }

    const handleClose = () => {
        setNewData(defaultData);
        onHandleClose();
    }

    return (
        <>
            {showNew &&
                <Dialog
                    onClose={() => handleClose()}
                    open={showNew}
                    fullWidth={true}
                    id='add-new-dialog'
                    maxWidth="lg"
                >

                    {<NewOrEdit
                        rowData={newData}
                        columns={newColumns}
                        changedData={(data) => setNewData(data)}
                        lovs={lovs} />}


                    <DialogActions>
                        <Button disabled={isAdding} onClick={handleClose}>Close</Button>
                        <Button disabled={isAdding} onClick={handleClear}>Clear</Button>
                        <Button
                            onClick={handleUpdate}
                            id="add-item-button"
                            disabled={isAdding}
                            autoFocus >
                            Add
                        </Button>

                         <Button
                            onClick={handleUpdateAndClose}
                            id="add-and-close-item-button"
                            disabled={isAdding}
                            autoFocus >
                            Add and close
                        </Button>
                        {isAdding && <CircularProgress size={14} />}
                    </DialogActions>

                    

                </Dialog>
            }
        </>
    );


}
